<template>
  <div class="app-title mb-4">
    <BaseBreadCrumb />
    <div class="d-flex align-center justify-space-between">
      <h2>{{ title }} {{ yearPeriode }}</h2>
      <div class="d-inline d-flex">
        <span v-if="referralcode" class="mr-2 mt-2">{{ $t('content.referral') }} : </span>
        <h2 v-if="referralcode">{{ referralcode }}</h2>
        <div @click="dialogPopUp = true">
          <svg-icon v-if="referralcode && qrCode" icon="qrcode" class="primary--text ml-5 mr-5 mt-1" style="cursor: pointer;" />
        </div>
      </div>
      <div class="d-flex justify-end align-center" v-if="toggleExport">
        <v-btn color="primary" class="btn-primary-custom" @click="download" :loading="loadingDownload">{{ $t('download') }}</v-btn>
        <v-divider vertical class="mr-3 ml-3" dark />
        <v-btn color="primary" class="btn-primary-custom" @click="attachToggle">
          {{ $t('content.attach_content') }}
        </v-btn>
      </div>
      <slot name="right" />
      <v-dialog v-model="dialogPopUp" persistent max-width="607">
        <v-card class="pa-6">
          <div class="d-flex justify-center">
            <vue-qrcode :value="qrCode" tag="svg" :options="{ width: 148 }" />
          </div>
          <v-card-title class="headline d-flex justify-center">
            <strong class="title-modal">{{ referralcode }}</strong>
          </v-card-title>
          <v-card-text class="d-flex justify-center">
            <span class="body-modal">{{ $t('content.scan_qr') }}</span>
          </v-card-text>
          <v-card-text class="d-flex justify-center">
            <v-btn color="primary" class="btn-primary-custom" width="250" @click="dialogPopUp = false">
              OK
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Dialog export import -->
      <v-dialog v-model="dialogPopUpAttach" persistent max-width="607">
        <v-card>
          <v-card-title class="headline secondary white--text">
            {{ $t('content.attack_file_zip') }}
          </v-card-title>
          <v-card-subtitle class="headline d-flex justify-center pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <form-group :name="$t('form.file')" :validator="$v.formAttach.file" no-gutter>
                  <template slot-scope="{ attrs }">
                    <v-file-input
                      :label="$t('form.file')"
                      accept=".zip"
                      chips
                      show-size
                      v-bind="attrs"
                      small-chips
                      v-model="formAttach.file"
                      truncate-length="15"
                      @input="$v.formAttach.file.$touch()"
                      @blur="$v.formAttach.file.$touch()"
                    ></v-file-input>
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <div class="d-flex justify-end align-center">
              <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closeDialogAttach">{{ $t('back') }}</v-btn>
              <v-btn color="primary" class="btn-primary-custom" :loading="loadingAttach" type="submit" @click="attach">{{ $t('submit') }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog list Assignment -->
      <v-dialog v-model="dialogPopUpAssignment" persistent max-width="607">
        <v-card>
          <v-card-title class="headline secondary white--text">
            {{ $t('content.attack_file_zip') }}
          </v-card-title>
          <v-card-subtitle class="headline d-flex justify-center pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <form-group :name="$t('menu.assignment')" no-gutter :validator="$v.formGroup.assignmentGroupId">
                  <template slot-scope="{ attrs }">
                    <v-select
                      v-bind="attrs"
                      v-model="formGroup.assignmentGroupId"
                      item-value="assignmentGroupId"
                      item-text="groupName"
                      clearable
                      :items="listAssignment"
                      @input="$v.formGroup.assignmentGroupId.$touch()"
                      @blur="$v.formGroup.assignmentGroupId.$touch()"
                      :label="$t('menu.assignment')"
                    />
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <div class="d-flex justify-end align-center">
              <v-btn color="primary" class="btn-primary-custom" :loading="loadingGroup" type="submit" @click="submitGroup">{{ $t('submit') }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from '@/components/base/BreadCrumb';
import VueQrcode from 'vue-qrcode';
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { fileType } from '@/validators';

const extAllowed = ['zip'];

export default {
  name: 'BaseTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    yearPeriode: {
      type: String,
      default: ''
    },
    referralcode: {
      type: String,
      default: ''
    },
    qrCode: {
      type: String,
      default: ''
    },
    toggleExport: {
      type: Boolean,
      default: false
    },
    fileZip: {
      type: String,
      default: ''
    }
  },
  validations() {
    return {
      formAttach: {
        file: {
          required,
          fileType: fileType(extAllowed)
        }
      },
      formGroup: {
        assignmentGroupId: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  components: {
    BaseBreadCrumb,
    VueQrcode
  },
  data: () => ({
    dialogPopUp: false,
    dialogPopUpAttach: false,
    dialogPopUpAssignment: false,
    loadingDownload: false,
    loadingAttach: false,
    loadingGroup: false,
    listAssignment: [],
    canBeExported: false,
    typeError: '',
    formAttach: {
      file: null,
      fileName: ''
    },
    formGroup: {
      assignmentGroupId: ''
    }
  }),
  methods: {
    getCheckImport() {
      this.loading = true;
      this.$store
        .dispatch(`Class/checkStatusImportExport`, {
          classId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId
        })
        .then(data => (this.canBeExported = data.canBeExported))
        .finally(() => (this.loading = false));
    },
    closeDialogAttach() {
      this.dialogPopUpAttach = false;
      this.formAttach.file = null;
      this.$v.$reset();
    },
    download() {
      if (this.canBeExported) {
        this.loadingDownload = true;
        const { classId, courseId } = this.$route.params;
        this.$store
          .dispatch('ExportClass/download', {
            classId,
            courseId,
            classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
          })
          .then(response => {
            let blob = new Blob([response.data], { type: 'octet/stream' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.fileZip}`;
            link.click();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loadingDownload = false));
      } else {
        this.$store.dispatch('general/showErrorNotification', {
          message: `Unable to download, you have to assign one of the contents in this menu `
        });
      }
    },
    attachToggle() {
      this.dialogPopUpAttach = true;
    },
    attach() {
      this.$v.formAttach.$touch();
      if (this.$v.formAttach.$invalid) return false;

      this.loadingAttach = true;

      var fpath = this.formAttach.file.name;

      fpath = fpath.replace(/\\/g, '/');

      var fname = fpath.substring(fpath.lastIndexOf('/') + 1, fpath.lastIndexOf('.'));

      if (/^[a-zA-Z0-9|.| |_|-]*$/i.test(fname)) {
        this.formAttach.fileName = fname;
        const { classId, courseId, classSectionId } = this.$route.params;
        this.$store
          .dispatch('ExportClass/attach', { classId, courseId, classSectionId, ...this.formAttach })
          .then(({ data, errorMessages }) => {
            // check error message
            if (parseInt(errorMessages) === 1) {
              this.$store
                .dispatch('ExportClass/getFileNameClassroom', this.formAttach.file.name)
                .then(response => {
                  this.listAssignment = response;
                  this.dialogPopUpAssignment = true;
                  this.typeError = parseInt(errorMessages);
                })
                .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
            } else if (parseInt(errorMessages) === 2) {
              const { classId, courseId } = this.$route.params;
              this.$store
                .dispatch('ExportClass/getFileNameClassroomDua', { classId, courseId })
                .then(response => {
                  this.listAssignment = response;
                  this.dialogPopUpAssignment = true;
                  this.typeError = parseInt(errorMessages);
                })
                .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
            }

            // check error sukses
            if (data.errorImports.length === 0) {
              this.$store.dispatch('general/showSuccessNotification', { message: data.message });
              this.formAttach.file = null;
              this.formAttach.fileName = null;
            } else {
              var datas = '';
              data.errorImports.forEach(element => {
                datas +=
                  `
              ` +
                  element.message +
                  `
              `;
              });
              this.$store.dispatch('general/showErrorNotification', { message: datas });
              this.formAttach.file = null;
              this.formAttach.fileName = null;
            }
          })
          // .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => {
            this.loadingAttach = false;
            this.dialogPopUpAttach = false;
            this.$v.$reset();
          });
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.word_upload') });
        this.loadingAttach = false;
        this.dialogPopUpAttach = false;
        this.formAttach.file = null;
        this.formAttach.fileName = null;
        this.$v.$reset();
      }
    },
    submitGroup() {
      this.$v.formGroup.$touch();
      if (this.$v.formGroup.$invalid) return false;
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch(`ExportClass/${this.typeError === 1 ? 'statusCodeSatu' : 'statusCodeDua'}`, {
          classroomId: classId,
          courseId,
          ...this.formGroup,
          file: this.formAttach.file
        })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success' });
          this.$v.$reset();
          this.typeError = '';
          this.dialogPopUpAssignment = false;
          this.formAttach.file = null;
          this.formAttach.fileName = null;
        });
    }
  },
  created() {
    if (this.toggleExport) {
      this.getCheckImport();
    }
  }
};
</script>

<style lang="scss">
.app-title {
  color: #fff;
  font-family: Montserrat;
}
.title-modal {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
}
.body-modal {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
